import { formatAmount } from "@graffer-inc/cloud-gov-core";
import * as React from "react";

export const RefundTotal: React.FC<{
  paymentResult: number;
}> = ({ paymentResult }) => {
  return (
    <div className="pl-1 has-text-right">
      <p
        style={{
          borderBottom: "solid 1px lightgrey",
        }}
      >
        <span className="mr-4 is-size-6">返金合計額</span>
        <span className="is-size-3-mobile is-size-2-desktop">
          {paymentResult ? formatAmount(paymentResult) : " - "}
        </span>
        <span className="ml-1 is-size-6">円</span>
      </p>
    </div>
  );
};
